import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logo-light.png";
import "./Sidebar.css";

export default function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <img src={logo} alt="ScannerPro" />
      </div>

      <ul className="sidebar-links">
        <li><NavLink to="/">🏠 Home</NavLink></li>
        <li><NavLink to="/jogos-dia">⚽ Jogos do Dia</NavLink></li>
        <li><NavLink to="/ranking">🏆 Ranking da Rodada</NavLink></li>
        <li><NavLink to="/contato">📬 Contato</NavLink></li>
      </ul>

      <p className="sidebar-version">Versão 1.0.0 © 2026 ScannerPro</p>
    </aside>
  );
}
